// -----------------------------
// ------------ Remote
// -----------------------------
export const REMOTE_REQUEST_PERIOD_IN_MS = 'REMOTE_REQUEST_PERIOD_IN_MS';

// -----------------------------
// ------------ Events
// -----------------------------
export const EVENT_REQUEST_PERIOD_IN_MS = 'EVENT_REQUEST_PERIOD_IN_MS';
export const NOTIFICATION_REQUEST_PERIOD_IN_MS = 'NOTIFICATION_REQUEST_PERIOD_IN_MS';
export const NOTIFICATION_SEARCH_LIMIT = 'NOTIFICATION_SEARCH_LIMIT';
// -----------------------------
// ------------ FAQ
// -----------------------------
export const FAQ_MINIMUM_LENGTH_BEFORE_SEARCH = 'FAQ_MINIMUM_LENGTH_BEFORE_SEARCH';
export const FAQ_SEARCH_LIMIT = 'FAQ_SEARCH_LIMIT';
export const FAQ_DEBOUNCE_IN_MS = 'FAQ_DEBOUNCE_IN_MS';
